import { Component, State, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-iws-dynamic-input",
    styleUrl: "dynamic-input.scss",
    shadow: false,
})
export class DynamicInput {
    private baseClass: string = "ux-iws-dynamic-input";

    /** Add input text */
    @Prop() addText: string = "+ add another error number";
    /** Input names with dynamically generated suffixes */
    @Prop() inputName: string = "errorNumber";
    /** Initial items to be displayed */
    @Prop() initItems: number = 1;
    /** Minimum items to be displayed */
    @Prop() minItems: number = 1;
    /** Maximum items to be displayed */
    @Prop() maxItems: number = 6;
    /** Counter for adding items  */
    @State() counter: number = 0;
    /** Dynamic items */
    @State() items: string[] = [];
    /** Minimum items reached */
    @State() minReached: boolean = false;
    /** Maximum items reached */
    @State() maxReached: boolean = false;

    componentWillLoad() {
        this.setInitItems();
    }

    private setInitItems = () => {
        for (let i = 0; i < this.initItems; i++) {
            this.counter++;
            this.items.push(this.listItemElement());
        }
        this.checkMinMaxReached();
    };

    private addInput = () => {
        if (this.counter < this.maxItems) {
            this.counter++;
            this.items.push(this.listItemElement());
            this.minReached = false;
            this.checkMinMaxReached();
        }
    };

    private removeInput = (event: Event) => {
        if (this.counter > this.minItems) {
            this.counter--;
            let target = (event.target as HTMLElement).closest("ux-icon");
            let index = [
                ...target.parentElement.parentElement.children,
            ].indexOf(target.parentElement);
            target.parentElement.parentElement.removeChild(
                target.parentElement
            );
            this.items.splice(index, 1);
            this.checkMinMaxReached();
        }
    };

    private checkMinMaxReached = () => {
        this.counter == this.minItems
            ? (this.minReached = true)
            : (this.minReached = false);

        this.counter == this.maxItems
            ? (this.maxReached = true)
            : (this.maxReached = false);
    };

    private listItemElement = () => {
        return (
            <div class={`${this.baseClass}__input-container`}>
                <input class="ux-input" type="text" name={this.inputName} />
                <ux-icon
                    name="delete"
                    onClick={(e) => this.removeInput(e)}
                ></ux-icon>
            </div>
        );
    };

    render() {
        return (
            <Host class={`${this.baseClass}`}>
                <div
                    class={`${this.baseClass}__dynamic-container ${
                        this.minReached ? "is-min-reached" : ""
                    }`}
                >
                    {this.items.map((item) => {
                        return item;
                    })}
                </div>
                <div
                    class={`ux-text-link ux-text-link--green ${
                        this.maxReached ? "is-max-reached" : ""
                    }`}
                    onClick={this.addInput}
                >
                    {this.addText}
                </div>
            </Host>
        );
    }
}
